import { SvgIcon, SvgIconProps } from '@mui/material';

const Icon = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon {...props} sx={{ width: 20, height: 20, stroke: '#344054', fill: 'transparent', ...sx }} viewBox="0 0 20 20" fill="none">
    <path d="M12.5 17.5L15.8333 17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333L17.5 4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5L12.5 2.5L12.5 9.58333L12.5 17.5Z" fill="#344054" />
    <path
      d="M15.8333 17.5L4.16667 17.5C3.24619 17.5 2.5 16.7538 2.5 15.8333L2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5M15.8333 17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333L17.5 4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5M15.8333 17.5L12.5 17.5L12.5 9.58333L12.5 2.5M4.16667 2.5L15.8333 2.5M4.16667 2.5L12.5 2.5M15.8333 2.5L12.5 2.5"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default Icon;
